import React from 'react';
import './Publications.css';
import Submenu from '../../components/Submenu';
import { PublicationItem } from '../../components/ContentItems';
import { useContent } from '../../context/ContentContext';
import { PUBLICATION_CATEGORIES } from '../../config/airtable';
import { publicationSectionKeys } from '../../data/fallbackContent';

const Publications = () => {
  const { publications, siteContent } = useContent();

  const publicationsByCategory = PUBLICATION_CATEGORIES.reduce((acc, category) => {
    acc[category] = publications
      .filter((pub) => pub.category === category)
      .sort((a, b) => a.sortOrder - b.sortOrder);
    return acc;
  }, {});

  return (
    <>
      <div className="publications">
        <Submenu />
        <h2>{siteContent.writing_heading}</h2>
        {PUBLICATION_CATEGORIES.map((category) => {
          const items = publicationsByCategory[category];
          if (!items.length) return null;

          return (
            <React.Fragment key={category}>
              <h3>{siteContent[publicationSectionKeys[category]]}</h3>
              {items.map((publication) => (
                <PublicationItem
                  key={publication.id || `${category}-${publication.sortOrder}-${publication.title}`}
                  publication={publication}
                />
              ))}
              <br />
            </React.Fragment>
          );
        })}
      </div>
    </>
  );
};

export default Publications;
